export enum SearchPanelSubSectionsIdsEnum {
    AccuracyLevel = 'accuracy_level',
    CrmOwnedAccounts = 'crm_owned_accounts',
    CrmOwnedContacts = 'crm_owned_contacts',
    JobStartDate = 'job_start_date',
    LastModifiedDate = 'last_modified_date',
    Rankings = 'rankings',
    ResultsInclude = 'results_include',
    YourLists = 'your_lists',
    ICPIntelModel = 'icp_intel_model',
}
